import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { LinkPrimitive } from '../link-primitive/link-primitive.js';
import { icon, baseIconButton } from '../buttons/base-icon-button.module.css.js';
import { primary, fullRadius, highlighted, iconButton, secondary, ghost, largeSize } from '../buttons/icon-button/icon-button.module.css.js';

const VARIANT_CLASSES = {
    ghost: ghost,
    secondary: secondary,
    highlighted: highlighted,
    highlightedCircle: clsx(highlighted, fullRadius),
    primary: primary,
    primaryCircle: clsx(primary, fullRadius),
};
/**
 * A link (anchor) that looks exactly like an {@link IconButton} — the anchor
 * analog of `IconButton`, the way `Link.Button` is the anchor analog of
 * `Button`. Use it for an icon-only control whose purpose is to navigate
 * (carries an `href`), so it exposes the `link` role to assistive tech and
 * supports middle-click / open-in-new-tab — without setting an explicit role.
 *
 * @see https://fpl.figma.design/components/buttons/icon-button/
 */
const LinkIconButton = forwardRef(({ children, variant = 'ghost', size = 'md', shape = 'square', ...props }, ref) => {
    // Mirror IconButton: surface aria-label as the tooltip unless one is set
    // explicitly (look for key presence so `data-tooltip={undefined}` can clear it).
    let dataTooltip = props['aria-label'];
    if ('data-tooltip' in props) {
        dataTooltip = props['data-tooltip'];
    }
    const dataTooltipType = props['data-tooltip-type'] || 'text';
    return (jsx(LinkPrimitive, { "data-fpl-component": "", ...props, ref: ref, "data-show-focus": true, "data-tooltip": dataTooltip, "data-tooltip-type": dataTooltipType, className: clsx(baseIconButton, iconButton, VARIANT_CLASSES[variant], {
            [fullRadius]: shape === 'circle',
            [largeSize]: size === 'lg',
        }), children: jsx("span", { "aria-hidden": true, className: icon, children: children }) }));
});
LinkIconButton.displayName = 'LinkIconButton';

export { LinkIconButton };
//# sourceMappingURL=link-icon-button.js.map
